import React from 'react';
import log from 'loglevel';

import Logger from '@src/helpers/logger';

type LoggerContextValue = typeof log | undefined;

const LoggerContext = React.createContext<LoggerContextValue>(undefined);
LoggerContext.displayName = 'Logger';

const LoggerProvider: React.FC = ({ children }) => {
  const _logger = React.useRef(log).current;

  return (
    <LoggerContext.Provider value={_logger}>{children}</LoggerContext.Provider>
  );
};

const useLogger = (scope: string) => {
  const _logger = React.useContext(LoggerContext);

  if (!_logger) {
    throw new Error('`useLogger` must be use within `LoggerProvider`');
  }

  const logger = new Logger(_logger, scope);

  return React.useMemo(() => logger, [logger]);
};

export { LoggerProvider };
export default useLogger;
